const doc = [({"da":({"js":({"admin":({"toggle_eye_button":({"the_model_was_saved":"Modellen blev gemt."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;